<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
    <!-- Data Workshop -->
    <CCardBody >
      <CRow>
        <div class="col-sm-12 col-xl-12">
            <h5>Filter</h5>
        </div>
        <div class="col-sm-12 col-xl-12">
          <div class="form-group">
            <label for="" class="font-weight-bold">Tanggal Pelaksanaan</label>
            <input type="text" name="daterange" id class="form-control" placeholder="Pilih Tanggal" autocomplete="off"/>
          </div>
        </div>
      </CRow>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input
              type="text"
              name
              id
              class="form-control"
              placeholder="Cari Data ..."
              @keyup="cariData"
              v-model="search"
            />
          </div>
        </div>
      </CRow>
      <CRow ref="mycardloader"> 
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{ indexed == 0 ? index +1: index+indexed + 1 }}</td>
            </template>
            <template #statusWorkshop="{item}">
              <td class="py-2">
                <font-awesome-icon
                  icon="check"
                  class="text-success"
                  v-if="item.statusWorkshop == 1"
                />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #kode_workshop="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.kode_workshop ? item.kode_workshop : "-"}}</td>
            </template>
            <template #nama_level="{item}">
              <td class="py-2 text-center">{{item.nama_level ? item.nama_level : "-"}}</td>
            </template>
            <template #biaya="{item}">
              <td
                class="py-2 text-center"
                align="left"
              >Rp. {{formatPrice(item.biaya) ? formatPrice(item.biaya) : "-"}}</td>
            </template>
            <template #tanggal_mulai="{item}">
              <td class="py-2 text-center">{{item.tanggal_mulai ? item.tanggal_mulai : "-"}}</td>
            </template>
            <template #tanggal_berakhir="{item}">
              <td class="py-2 text-center">{{item.tanggal_berakhir ? item.tanggal_berakhir : "-"}}</td>
            </template>
            <template #lokasi="{item}">
              <td class="py-2 text-center">{{item.lokasi ? item.lokasi : "-"}}</td>
            </template>
            <template #kapasitas="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.kapasitas ? item.kapasitas + '/' + item.sisa : "-"}}</td>
            </template>            
            <template #aksi="{item, index}">
              <td class="py-2 text-center">
               
                <router-link :to="'/sertifikasi/master-rpl-acpa/edit/'+item.id_sertifikasi_rpl">
                  <CButton v-c-tooltip="'Ubah'" color="info" class="btn-sm mx-1" square>
                    <font-awesome-icon icon="edit" />
                  </CButton>
                </router-link>&nbsp;&nbsp;
                <CButton v-c-tooltip="'Hapus '" color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
    </CCardBody>
    <!-- End Data provinsi -->
</template>
<script>
import RplLainnyaService from "@/services/sertifikasi/master-rpl-lainnya.service";

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    key: "kode_rpl",
    label: "Kode",
    sorter: true,
    filter: false
  },
  {
    key: "nama_rpl",
    label: "Nama",
    sorter: true,
    filter: false
  },
  {
    key: "nama_level",
    label: "Level",
    sorter: true,
    filter: false
  },
  {
    key: "biaya",
    label: "Harga",
    sorter: true,
    filter: false
  },
  {
    key: "tanggal_mulai",
    label: "Tanggal Dimulai",
    sorter: true,
    filter: false
  },
  {
    key: "tanggal_berakhir",
    label: "Tanggal Berakhir",
    sorter: true,
    filter: false
  },
  {
    key: "lokasi",
    label: "Lokasi",
    sorter: true,
    filter: false
  },
  {
    key: "kapasitas",
    label: "Kapasitas",
    sorter: true,
    filter: false
  },  
  {
    key: "aksi",
    _style: "width:12%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: "MasterRplWorkshop",
  data() {
    return {
      pageSize: "",
      search: "",
      fields,
      pagination: {
        totalPages: 0
      },
      currentPage: 0,
      details: [],
      no: 1,
      items: [],
      Level: [],
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      indexed: 0,
      loading: true
    };
  },
  mounted() {
    this.getData("0", this.pageSize, "default");
    $(function() {
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "auto",
          autoApply: true,
          singleDatePicker: true,
        },
        function(start, end, label) {
          // comment console console.log(
            
        }
      );
    });
  },
  watch: {
    currentPage: function(val){
      //alert val -1 
      var page = val - 1;
      this.indexed = page * 10;
      this.getData(val - 1, this.pageSize, this.search);
    }
  },
  methods: {
    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },
    pageChange() {
      this.getData(this.currentPage, this.pageSize, this.search);
    },
    cariData(){
      this.getData("0", this.pageSize, this.search);
    },
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    deleteData(item) {
      var vm = this;
      // comment console console.log(item)
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            RplLainnyaService.deleteRplWorkshop(item.id_sertifikasi_rpl)
            .then(response => {
              // comment console console.log(response);
              vm.alertSuccess();
              vm.getData("0", this.pageSize, this.search);
            })
            .catch(error => {
              vm.alertError();
              // comment console console.log(error);
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.mycardloader,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      RplLainnyaService.getRplLainnya(currentPage, pageSize, filter)
        .then(response => {
          loader.hide();
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;

          setTimeout(() => loader.hide(), 1000);
          // loader.hide();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
 

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>